import { render } from "./performance.vue?vue&type=template&id=ef9fd28c&scoped=true"
import script from "./performance.vue?vue&type=script&lang=js"
export * from "./performance.vue?vue&type=script&lang=js"

import "./performance.vue?vue&type=style&index=0&id=ef9fd28c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef9fd28c"

export default script